import styled, { css } from 'styled-components';
import { Link } from 'react-router';
import { transparentize } from 'polished';

const TableLink = styled(Link)(
  ({ theme }) => css`
    color: inherit;
    text-decoration: none;
    display: block;
    padding: 8px 12px;
    border-radius: 10px;
    transition: 0.05s ease-in-out;

    &:hover,
    &:focus {
      background: ${transparentize(0.85, theme.colors.primary)};
    }
  `,
);

export default TableLink;
